import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import { BillingPlanIds } from '../../../../../enums/billing-plan-ids';
import { getDecimalsToDisplayFromPrice } from '../../../../../services/decimal-display-service';
import { useGetPlanPrice } from '../../hooks/use-plan-details';
import { messages } from '../../messages';

export const PriceValue = ({ plan, addOnPrice = 0 }) => {
  const { billingPlanId } = plan;
  const planPrice = useGetPlanPrice(plan);

  if (BillingPlanIds.SSEnterpriseAU === parseInt(billingPlanId, 10)) {
    return <FormattedMessage {...messages.customPrice} />;
  }

  return (
    <FormattedCurrencyContainer
      currencyCode={planPrice.code}
      fractionDigits={getDecimalsToDisplayFromPrice(planPrice.value)}
      value={planPrice.value + addOnPrice}
    />
  );
};

PriceValue.propTypes = {
  plan: PropTypes.object.isRequired,
  addOnPrice: PropTypes.number,
};
